module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path !== '/AboutMe') ? _c('v-navigation-drawer', {
    staticClass: "pb-0 pt-5 mt-4",
    attrs: {
      "persistent": "",
      "absolute": "",
      "temporary": "",
      "height": "100%",
      "clipped": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.showSidebar),
      callback: function($$v) {
        _vm.showSidebar = $$v
      },
      expression: "showSidebar"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.heading) ? _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v(_vm._s(item.heading))]) : _vm._e()], 1)], 1) : (item.children) ? _c('v-list-group', {
      attrs: {
        "no-action": ""
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          item.model = $$v
        },
        expression: "item.model"
      }
    }, [_c('v-list-tile', {
      slot: "item"
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.model ? item.icon : item['icon-alt']))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.text) + " ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "to": {
            path: '/' + child.path
          }
        },
        nativeOn: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.toggleSidebar()
          }
        }
      }, [(child.icon) ? _c('v-list-tile-action', {
        staticClass: "ml-4"
      }, [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(child.text))])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "to": {
          path: '/' + item.path
        }
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleSidebar()
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.text))])], 1)], 1)]
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a15a50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 60
// module chunks = 8